/* Alkoholgehalt-Badge - Interaktion des Info-Punkts.
   Gehoert zu snippets/alkohol-badge.liquid und assets/alkohol-badge.css.
   Einbau in layout/theme.liquid vor </body>:
   <script src="{{ 'alkohol-badge.js' | asset_url }}" defer></script>

   Bewusst als Asset und nicht im Snippet: Shopify laedt das Kollektions-Grid
   beim Filtern, Sortieren und Nachladen per Section Rendering neu. Dabei
   eingefuegte <script>-Tags fuehrt der Browser nicht aus - die Kacheln waeren
   danach tot. Alle Listener haengen deshalb am document und ueberleben jedes
   Neurendern des Grids. */

(function () {
  'use strict';

  var timer = null;
  var floater = null;

  function holeFloater() {
    if (floater && floater.parentNode) return floater;
    floater = document.createElement('div');
    floater.className = 'alk-tip-float';
    floater.setAttribute('role', 'tooltip');
    document.body.appendChild(floater);
    return floater;
  }

  /* Findet das Badge auch dann, wenn ein Theme-Element darueberliegt und den
     Klick abfaengt. elementsFromPoint liefert den kompletten Stapel unter dem
     Zeiger, unabhaengig von der Stapelreihenfolge. */
  function badgeAnPunkt(x, y) {
    if (!x && !y) return null;
    if (!document.elementsFromPoint) return null;
    var stapel = document.elementsFromPoint(x, y);
    for (var i = 0; i < stapel.length; i++) {
      var el = stapel[i];
      if (!el || !el.closest) continue;
      var box = el.closest('.alk');
      if (box) return box.querySelector('[data-alk-info]');
    }
    return null;
  }

  function findeButton(e) {
    if (!e.target || !e.target.closest) return null;
    var btn = e.target.closest('[data-alk-info]');
    if (btn) return btn;
    return badgeAnPunkt(e.clientX, e.clientY);
  }

  function platzieren(box) {
    var btn = box.querySelector('[data-alk-info]');
    var quelle = box.querySelector('.alk__tip');
    if (!btn || !quelle) return;

    var tip = holeFloater();
    tip.innerHTML = quelle.innerHTML;
    tip.style.visibility = 'hidden';
    tip.style.opacity = '0';
    tip.classList.add('is-open');
    box.classList.add('is-open');

    var r = btn.getBoundingClientRect();
    var b = tip.getBoundingClientRect();

    var links = r.left + r.width / 2 - b.width / 2;
    var max = window.innerWidth - b.width - 8;
    if (links > max) links = max;
    if (links < 8) links = 8;

    /* Zuerst nach oben oeffnen: unterhalb des Badges liegt auf der
       Produktseite der Warenkorb-Button. */
    var oben = r.top - b.height - 8;
    if (oben < 8) oben = r.bottom + 8;

    tip.style.left = links + 'px';
    tip.style.top = oben + 'px';
    tip.style.visibility = '';
    tip.style.opacity = '';
  }

  function schliessen() {
    var offene = document.querySelectorAll('.alk.is-open');
    for (var i = 0; i < offene.length; i++) {
      offene[i].classList.remove('is-open');
      var b = offene[i].querySelector('[data-alk-info]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    if (floater) floater.classList.remove('is-open');
    clearTimeout(timer);
  }

  /* Manche Theme-Handler navigieren schon vor dem click. */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (typ) {
    document.addEventListener(typ, function (e) {
      if (findeButton(e)) e.stopPropagation();
    }, true);
  });

  document.addEventListener('click', function (e) {
    var btn = findeButton(e);
    if (!btn) { schliessen(); return; }

    e.preventDefault();
    e.stopPropagation();

    var box = btn.closest('.alk');
    var offen = box.classList.contains('is-open');
    schliessen();
    if (!offen) {
      platzieren(box);
      btn.setAttribute('aria-expanded', 'true');
      timer = setTimeout(schliessen, 4000);
    }
  }, true);

  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var direkt = e.target.closest('[data-alk-info]');
    var btn = direkt || findeButton(e);
    if (!btn) return;

    var box = btn.closest('.alk');
    if (box.classList.contains('is-open')) return;
    schliessen();
    platzieren(box);

    /* Liegt etwas darueber, kommt kein mouseout am Button an. */
    if (!direkt) {
      clearTimeout(timer);
      timer = setTimeout(schliessen, 4000);
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-alk-info]');
    if (btn && !e.relatedTarget) return;
    if (btn) {
      clearTimeout(timer);
      timer = setTimeout(schliessen, 300);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') schliessen();
  });

  window.addEventListener('scroll', schliessen, { passive: true });
  window.addEventListener('resize', schliessen);
})();